class HeaderMenu extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.parent-mega-menu__link');
    this.panel = this.querySelector('.mega-menu__content');

    if (!this.trigger || !this.panel) return;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleTriggerPointerDown = this.handleTriggerPointerDown.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);

    this.isTouchActivation = false;
    this.preventTouchNavigation = false;

    this.trigger.setAttribute('aria-expanded', 'false');
    this.panel.hidden = true;

    this.addEventListener('mouseenter', this.open);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.addEventListener('focusin', this.open);
    this.addEventListener('focusout', this.handleFocusOut);
    this.addEventListener('keyup', this.handleKeyUp);
    this.trigger.addEventListener('pointerdown', this.handleTriggerPointerDown);
    this.trigger.addEventListener('click', this.handleTriggerClick);
  }

  isOpen() {
    return this.classList.contains('is-open');
  }

  open() {
    if (this.isOpen()) return;

    document.querySelectorAll('header-menu.mega-menu.is-open').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });

    this.classList.add('is-open');
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.dataset.megaArmed = 'false';
  }

  handleMouseLeave() {
    if (!this.contains(document.activeElement)) this.close();
  }

  handleFocusOut() {
    requestAnimationFrame(() => {
      if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close();
    });
  }

  handleKeyUp(event) {
    if (event.key !== 'Escape' || !this.isOpen()) return;

    this.trigger.focus();
    this.close();
  }

  handleTriggerPointerDown(event) {
    this.isTouchActivation = event.pointerType === 'touch' || event.pointerType === 'pen';

    if (!this.isTouchActivation || window.innerWidth < 990) return;

    const isArmed = this.trigger.dataset.megaArmed === 'true';

    if (!this.isOpen() || !isArmed) {
      this.open();
      this.trigger.dataset.megaArmed = 'true';
      this.preventTouchNavigation = true;
      return;
    }

    this.preventTouchNavigation = false;
  }

  handleTriggerClick(event) {
    if (event.detail === 0) {
      this.isTouchActivation = false;
      this.preventTouchNavigation = false;
      return;
    }

    if (!this.isTouchActivation || window.innerWidth < 990) return;

    this.isTouchActivation = false;

    if (this.preventTouchNavigation) {
      event.preventDefault();
      event.stopPropagation();
      this.preventTouchNavigation = false;
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.trigger.dataset.megaArmed = 'false';
    window.location.href = this.trigger.href;
  }
}

customElements.define('header-menu', HeaderMenu);
